<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="pile_box">
          <el-row :gutter="10">
            <el-col :xs="8" :sm="6" :md="12" :lg="6" :xl="6">
              <div class="pile_gun_item_box cos_box">
                <div class="box">
                  <div class="box_item box1"></div>
                  <div class="box_item box2"></div>
                  <div class="box3"></div>
                </div>
                <div class="cos_text">{{ detailsData.soc }}%</div>
              </div>
            </el-col>
            <el-col :xs="4" :sm="6" :md="12" :lg="6" :xl="6">
              <div class="pile_gun_box">
                <div class="status_title">{{ $t('chong-dian-zhong') }}</div>
                <ul>
                  <li>
                    <span>{{ $t('chargingMonitor.GunNumber') }}</span>
                    {{ detailsData.gunCode }}
                  </li>
                  <li>
                    <span>{{ $t('siteManager.stationType') }}</span>
                    {{ gunType(detailsData.gunType) }}
                  </li>
                  <li>
                    <span>{{ $t('chong-dian-mo-shi-0') }}</span>
                    {{ startType(detailsData.startWay) }}
                  </li>
                  <li>
                    <span>{{ $t('chong-dian-xie-yi') }}</span>
                    {{ detailsData.protocol }}
                  </li>
                </ul>
              </div>
            </el-col>
            <el-col :xs="4" :sm="6" :md="12" :lg="6" :xl="6">
              <div class="pile_gun_box">
                <div class="status_title"></div>
                <ul>
                  <li>
                    <span>{{ $t('screen.user') }}</span>
                    {{ detailsData.phone }}
                  </li>
                  <li>
                    <span>{{ $t('kai-shi-shi-jian') }}</span>
                    {{ detailsData.startTime }}
                  </li>
                  <li>
                    <span>{{ $t('chi-xu-shi-jian') }}</span>
                    {{ chargeTime(detailsData.totalTime) }}
                  </li>
                  <li>
                    <span>{{ $t('screen.ChargingAmount') }}</span>
                    {{ detailsData.fee }}
                  </li>
                </ul>
              </div>
            </el-col>
            <el-col :xs="8" :sm="6" :md="12" :lg="6" :xl="6">
              <div style="position: relative">
                <div id="electricChart" class="electricChart"></div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :span="24">
        <div style="width: 100%">
          <div style="width: 100%; height: 300px" id="batteryChart"></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Chart from "echarts";
// import { chart } from 'highcharts';
export default {

  name: "chargingMonitorDetails",
  props: {
    detailsData: {
      type: Object,
      required: {},
    },
    lineChartLength: {
      type: Number,
      required: 10,
    },
  },
  data() {
    
    return {
      echartsData: {},
      batteryChart: null,
      electricChart: null,
    };
  },
  computed: {
    gunType: function () {
      const that = this;
      return function (gunType) {
        console.log("gunType:" + gunType);
        if (gunType === "S") {
          return that.$t('chargingMonitor.exchange');
        } else if (gunType === "F") {
          return that.$t('chargingMonitor.directCurrent');
        } else {
          return that.$t('chargingMonitor.unknown');
        }
      };
    },
    startType: function () {
      const that = this;
      return function (startType) {
        if (startType === "0") {
          return that.$t('chargingMonitor.SwipeCardActivation');
        } else if (startType === "1") {
          return that.$t('chargingMonitor.ScanCodeToStart');
        } else {
          return that.$t('chargingMonitor.NotStarted');
        }
      };
    },
    startType: function () {
      const that = this;
      return function (startType) {
        if (startType === "0") {
          return that.$t('chargingMonitor.SwipeCardActivation');
        } else if (startType === "1") {
          return that.$t('chargingMonitor.ScanCodeToStart');
        } else {
          return that.$t('chargingMonitor.NotStarted');
        }
      };
    },
    chargeTime: function () {
      return function (totalTime) {
        let chargeMin = Math.floor(totalTime / 60);
        let chargeSecond = totalTime % 60;
        let chargeHour = Math.floor(chargeMin / 60);
        chargeMin = chargeMin % 60;
        chargeMin = chargeMin > 10 ? chargeMin : "0" + chargeMin;
        chargeSecond = chargeSecond > 10 ? chargeSecond : "0" + chargeSecond;
        chargeHour = chargeHour > 10 ? chargeHour : "0" + chargeHour;
        return chargeHour + ":" + chargeMin + ":" + chargeSecond;
      };
    },
  },
  watch: {
    detailsData(detailsData) {
      // if (detailsData) {
      //   this.echartsData = detailsData;
      //   if (detailsData.timeData.length > 0) {
      this.initBatteryChart();
      //   }
      // }
    },
  },
  created() {},
  mounted() {
    this.batteryChart = Chart.init(document.getElementById("batteryChart"));
    this.electricChart = Chart.init(document.getElementById("electricChart"));
    this.initBatteryChart();
    this.initElectricChart();
    window.onresize = () => {
      return (() => {
        this.batteryChart.resize();
        this.electricChart.resize();
      })();
    };
  },
  methods: {
    initElectricChart() {
      this.electricChart.setOption({
        tooltip: {
          formatter: `{a} <br/>{b}${this.$t('chong-dian-wen-du')}: {c}℃`,
        },
        toolbox: {
          feature: {
            // restore: {},
            // saveAsImage: {},
          },
        },
        series: [
          {
            name: this.$t('dang-qian-wen-du'),
            type: "gauge",
            min: -50,
            max: 150,
            detail: { fontSize: 20, formatter: "{value}℃" },
            data: [{ value: this.detailsData.temperature }],
            splitLine: {
              length: 6,
              lineStyle: {
                width: 2,
                color: "#999",
              },
            },
            axisLine: {
              lineStyle: {
                width: 4,
                color: [
                  [0.25, "#4dabf7"],
                  [0.7, "#69db7c"],
                  [1, "#ff6b6b"],
                ],
              },
            },
          },
        ],
      });
    },
    initBatteryChart() {
      let voltageData = this.detailsData.voltageData;
      let currentData = this.detailsData.currentData;
      let powerData = this.detailsData.powerData;
      let timeData = this.detailsData.timeData;
      if (timeData && timeData.length < 10) {
        let data = [];
        for (let i = 0; i < 10 - timeData.length; i++) {
          data.push("*");
        }
        timeData = [...timeData, ...data];
      }
      console.log(timeData);
      this.batteryChart.setOption({
        title: {
          text: this.$t('chong-dian-qing-kuang-shi-shi-jian-kong'),
          left: "20",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          top: 20,
          icon: "rect",
          itemWidth: 14,
          itemHeight: 5,
          itemGap: 13,
          data: [this.$t('dian-liu-0'), this.$t('dian-ya-0'), this.$t('deviceControl.power')],
          right: "4%",
          textStyle: {
            fontSize: 12,
          },
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: "#57617B",
              },
            },
            data: timeData,
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: this.$t('dian-liu-0'),
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 1,
              },
            },
            areaStyle: {
              normal: {
                color: new Chart.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(137, 189, 27, 0.3)",
                    },
                    {
                      offset: 0.8,
                      color: "rgba(137, 189, 27, 0)",
                    },
                  ],
                  false
                ),
                shadowColor: "rgba(0, 0, 0, 0.1)",
                shadowBlur: 10,
              },
            },
            itemStyle: {
              normal: {
                color: "rgb(137,189,27)",
                borderColor: "rgba(137,189,2,0.27)",
                borderWidth: 12,
              },
            },
            data: currentData,
          },
          {
            name: this.$t('dian-ya-0'),
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 1,
              },
            },
            areaStyle: {
              normal: {
                color: new Chart.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(0, 136, 212, 0.3)",
                    },
                    {
                      offset: 0.8,
                      color: "rgba(0, 136, 212, 0)",
                    },
                  ],
                  false
                ),
                shadowColor: "rgba(0, 0, 0, 0.1)",
                shadowBlur: 10,
              },
            },
            itemStyle: {
              normal: {
                color: "rgb(0,136,212)",
                borderColor: "rgba(0,136,212,0.2)",
                borderWidth: 12,
              },
            },
            data: voltageData,
          },
          {
            name: this.$t('deviceControl.power'),
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 1,
              },
            },
            areaStyle: {
              normal: {
                color: new Chart.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(219, 50, 51, 0.3)",
                    },
                    {
                      offset: 0.8,
                      color: "rgba(219, 50, 51, 0)",
                    },
                  ],
                  false
                ),
                shadowColor: "rgba(0, 0, 0, 0.1)",
                shadowBlur: 10,
              },
            },
            itemStyle: {
              normal: {
                color: "rgb(219,50,51)",
                borderColor: "rgba(219,50,51,0.2)",
                borderWidth: 12,
              },
            },
            data: powerData,
          },
        ],
      });
    },
  },
};
</script>

<style lang="less" scoped>
ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
}

.pile_box {
  padding-left: 30px;
  box-sizing: border-box;
  padding-bottom: 60px;

  .pile_gun_item_box {
    margin-top: 30px;
    transform: translateX(30px);
  }

  .electricChart {
    width: 200px;
    height: 200px;
    position: absolute;
    top: -15px;
    left: 40px;
    z-index: 999;
  }
  .icon {
    transform: rotateY(-180deg);

    .icon-chongdianqiang {
      font-size: 40px;
      color: #ce1219 !important;
    }
  }

  .pile_gun_box {
    text-align: left;

    .status_title {
      color: #0081ff !important;
      height: 25px;
      line-height: 25px;
    }

    ul {
      display: block;

      li {
        color: #000;
        height: 25px;
        line-height: 25px;
        font-size: 13px;

        span {
          display: inline-block;
          width: 65px;
          color: #737780;
        }
      }
    }
    // div {
    //
    // }

    div:first-child {
      color: #000;
    }
  }
}
// .chart_item,
// #batteryChart {
//   width: 100%;
//   height: 300px;
// }

/*旋转动画*/
@keyframes moveover {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.cos_box {
  position: relative;
  top: -20px;
  width: 100px;
  height: 100px;
  .box {
    width: 100%;
    height: 100%;

    /*整体旋转*/
    animation: moveover 2.5s linear infinite;

    .box_item {
      position: absolute;
      width: 50px;
      height: 100px;
    }

    .box1 {
      border-radius: 50px 0 0 50px;
      /* 起始最深颜色为 #999，过渡到中间颜色为 #d0cfcf */
      background: linear-gradient(#0081ff, rgba(0, 129, 255, 0.5));
      z-index: 2;
    }
    .box2 {
      border-radius: 0 50px 50px 0;
      left: 50%;
      /* 过渡到中间颜色为 #d0cfcf 最终末尾颜色为 #eee */
      background: linear-gradient(#fff, rgba(0, 129, 255, 0.5));
      z-index: 1;
    }

    .box3 {
      position: absolute;
      width: 92px;
      height: 92px;
      top: 4px;
      left: 4px;
      border-radius: 50%;
      background-color: #fff;
      z-index: 2;
    }
  }
  .cos_text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #000;
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/module/operatingCenter/component/chargingMonitorDetails.vue